import { render } from "./Propostas.vue?vue&type=template&id=8eda88b0&scoped=true"
import script from "./Propostas.vue?vue&type=script&lang=js"
export * from "./Propostas.vue?vue&type=script&lang=js"

import "./Propostas.vue?vue&type=style&index=0&id=8eda88b0&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eda88b0"]])

export default __exports__